import React, { Component } from 'react';
import $ from 'jquery';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import API_Config from '../../API_Config';
import  './contactfrom.css';
import {Link} from 'react-router-dom';

class ContactForm extends Component {

    render() {

        return (
            <section class="ovrfl">
                <div class="container">
                    <div class="row breadcrumb text-center trght">
                        <div class="col-md-12">
                            <span><Link to="/">Home</Link></span> <i class="fa fa-angle-right"></i>
                            <span>Contact</span>
                        </div>
                    </div>
                    <div class="row pad_0 con_row">
                        <div class="con_row_bg">
                            <div class="col-md-6 col-xs-12 contact_bg">
                                <h3 class="cate_title bl-add pb">DROP US A LINE</h3>
                                <span class="chkemailcontact"></span>
                                <form class="contact_us_form" id="contact_us2" method="post" name="contact_us_form" inspfaactive="true">
                                    <span class="hidden" id="contact_error"></span>
                                    <div class="f-l">
                                        <label for="f-na" class="frn"><i class="fa fa-user"></i></label>
                                        <input type="text" name="name" id="f-na" placeholder="Full Name" class="frm-ele"></input>
                                    </div>
                                    <div class="f-l">
                                        <label for="f-a" class="frn"><i class="fa fa-envelope"></i></label>
                                        <input type="text" name="email" placeholder="Email Address" id="f-a" class="frm-ele f-l"></input>
                                    </div>
                                    <div class="f-l">
                                        <label for="f-n" class="frn"><i class="fa fa-phone"></i></label>
                                        <input type="number" name="phno" id="f-n" placeholder="Phone Number" class="frm-ele f-l" onBlur={(e) => this.isValidPhone(e)}></input>
                                        <input type="hidden" name="custom_user_session_id" id="custom_user_session_id" placeholder="custom_user_session_id" class="frm-ele f-l" value="ec08f4a5b501ccbec06ec66ec0c4cf34"></input>
                                    </div>
                                    <div class="f-l flla">
                                        <label for="f-nan" class="frn"><i class="fa fa-comment"></i></label>
                                        <textarea rows="6" name="desc" id="f-nan" placeholder="Other details" class="frm-ele f-l"></textarea>
                                    </div>
                                    <div>
                                        <button type="button" onClick={this.handleSubmit} class="re_but dc rlf" id="contact_us" name="submit">SEND MESSAGE</button>
                                    </div>
                                </form>
                            </div>
                            <div class="col-md-6 col-xs-12 contact_bg">
                                <h3 class="cate_title bl-add pb">OUR OFFICE</h3>
                                <div class="con_map">
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.7996284974274!2d78.33282967226484!3d17.421400978203113!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb937de0c9d873%3A0xa12c2f6df057db7!2sMordor+Intelligence!5e0!3m2!1sen!2sin!4v1470208864485"
                                            frameborder="0" class="Mordormap" allowfullscreen=""></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row pad_0 con_row row-eq-height">
                        <div class="col-md-4 con1_bg con1_bg1">
                            <div>
                                <i class="fa fa-map-marker"></i>
                                <h4 class="contact-headings"> Address</h4>
                                <p>5th Floor, Brigade Towers, Financial District, Gachibowli,Hyderabad - 500032,India</p>
                            </div>
                        </div>

                        <div class="col-md-4 con1_bg con1_bg2">
                            <div> <i class="fa fa-phone"></i>
                                <h4 class="contact-headings"> Phone</h4>
                                <p>+1 617-765-2493</p>
                            </div>
                        </div>

                        <div class="col-md-4 con1_bg con1_bg3">
                            <div> <i class="fa fa-envelope"></i>
                                <h4 class="contact-headings"> Email Address</h4>
                                <p>info@mordorintelligence.com</p>
                            </div>
                        </div>
                    </div>
                </div>
                <NotificationContainer />
            </section>
        );
    }

    isValidPhone(e) {
        console.log(e.target.value);
        if(e.target.value < 1) {
            console.log('invalid');
            e.target.style.border = '1px solid red';
            document.getElementById('contact_us').disabled = true;
            document.getElementById('contact_us').style.opacity = '0.4';
        }
        else {
            console.log('valid');
            e.target.style.border = '1px solid transparent';
            document.getElementById('contact_us').disabled = false;
            document.getElementById('contact_us').style.opacity = '1';
        }
    }

    handleSubmit() {
        var name = $("#f-na").val();
        var email = $("#f-a").val();
        var phone = $("#f-n").val();
        var description = $("#f-nan").val();

            var atpos = email.indexOf("@");
            var dotpos = email.lastIndexOf(".");
            if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= email.length) {
                NotificationManager.error('Error', 'Enter valid email id!', 5000);
                $("#f-a").focus();
                return false;
            }
            else{
                var postData =
                    {
                        name : name,
                        email : email,
                        phno : phone,
                        desc : description,
                        custom_user_session_id : localStorage.getItem('SessionID')
                    }
                $.ajax({
                    type: 'POST',
                    url: API_Config.http_url + API_Config.end_point.contactUs,
                    data: postData
                })
                    .done(function(data) {
                        NotificationManager.success('Success', 'Customization request accepted successfully', 5000);
                    })
                    .fail(function(jqXhr) {
                        NotificationManager.error('Error', 'Something went wrong!', 5000);
                    });


            }

    }


}


export default ContactForm;


// WEBPACK FOOTER //
// ./src/contact/form/ContactForm.js